module.exports = __webpack_public_path__ + "static/alte-haas-bold-1bdb4d7b631fda9742800e8bbcdda7a4.woff";